class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
  
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
  
    const formData = new FormData(this.form);
    const variantId = Number(formData.get('id'));
    const productId = Number(this.dataset.productId); // We'll add this attribute in Liquid
  
    // Only do linking logic for the main Stelz product
    if (productId === 15064271552836) {
      const sectionId = this.dataset.sectionId;
      const variantData = JSON.parse(document.getElementById(`variant-data-${sectionId}`).textContent);
      const matchedVariant = variantData.find(v => v.id === variantId);

      console.log(variantData);
      console.log(matchedVariant);
  
      if (matchedVariant?.variant_id) {
        console.log("Adding linked product ID:", matchedVariant.variant_id);
  
        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            id: matchedVariant.variant_id,
            quantity: 1,
            sections: this.cartNotification.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname
          })
        })
          .then(response => response.json())
          .then(parsedState => {
            this.cartNotification.renderContents(parsedState);
          })
          .catch(console.error)
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          });
  
        return; // Don't run default logic
      }
    }
  
    // Default fallback
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
  
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('product-form', ProductForm);
